import { useContext } from 'react';
import { TroubleShootingHandler } from '../../../../Pages/MainComponents/TroubleShooting/TroubleShooting';
import AudioService from '../../../../Services/AudioService';
import { CustomerServiceContactService } from '../../../../Services/Configuration/CustomerServiceContactService';
import { goToUrl } from '../../../../Utils/NavigationUtils';
import { RedoEasyFitContext, RedoEasyFitState } from '../RedoEasyFitContext';

function useRedoEasyFitTroubleShootingHandler(): TroubleShootingHandler {
    const { setRedoEasyFitState } = useContext(RedoEasyFitContext);

    const onStartAudioContext = async () => {
        await AudioService.serviceInstance.createNewAudioContext();
    };

    const onRetry = async () => {
        await onStartAudioContext();
        setRedoEasyFitState(RedoEasyFitState.OneSideSetUp);
    };

    const openConnectionSupportLink = () => {
        goToUrl(
            CustomerServiceContactService.getCountrySpecificOrionConnectionCheckAddress(
                false
            ),
            true
        );
    };

    const linkCallBacks = {
        connectionCheckSupport: openConnectionSupportLink,
    };

    return {
        onRetry,
        linkCallBacks,
    };
}

export default useRedoEasyFitTroubleShootingHandler;
